import type { FC, ReactNode } from "react";
import { cloneElement } from "react";

import type { IComponent } from "../Component";
import { defaultAttributes } from "../Component";

import * as css from "./Repeater.module.css";

export interface IItemTemplate extends Omit<IComponent, "children"> {
    children: ReactNode | ((props: object) => JSX.Element);
    childProps?: IComponent;
}

const ItemTemplate: FC<IItemTemplate> = (props) => (
    <div {...defaultAttributes(props, css.itemTemplateComponent)}>
        {props.children && typeof props.children === "function"
            ? props.children(props.childProps || {})
            : cloneElement(props.children as JSX.Element, props.childProps)}
    </div>
);

export type INoResultsTemplate = IComponent;

const NoResultsTemplate: FC<INoResultsTemplate> = (props) => (
    <div {...defaultAttributes(props, css.noResultsTemplateComponent)}>{props.children}</div>
);

export { NoResultsTemplate, ItemTemplate };
